document.addEventListener('DOMContentLoaded', () => {
    const items = document.querySelectorAll('.info-details-item');
    const loadMoreButton = document.getElementById('information__load-more');
    
    let visibleItemsCount = 24; // Number of items to show initially
    const itemsToShowIncrement = 12; // Number of items to show on each button click

    // Initially show only the first 'visibleItemsCount' items
    items.forEach((item, index) => {
        if (index < visibleItemsCount) {
            item.classList.add('information_show');
        } else {
            item.classList.add('information_hidden');
        }
    });
  
if(items.length <= visibleItemsCount){
  document.getElementById('information__load-more').style.display='none'
}
 
    loadMoreButton.addEventListener('click', () => {
        const hiddenItems = Array.from(items).filter(item => item.classList.contains('information_hidden'));
        
        if (hiddenItems.length > 0) {
            // Show the next set of items
            hiddenItems.slice(0, itemsToShowIncrement).forEach(item => {
                item.classList.remove('information_hidden');
                // Trigger a reflow to ensure the animation runs
                void item.offsetWidth;
                item.classList.add('information_show');
            });

            // Hide the button if all items are visible
            if (hiddenItems.length <= itemsToShowIncrement) {
                loadMoreButton.classList.add('information_hidden');
            }
        }
    });
});